<template>
  <div>
    <Sidebar />
    <div class="content">
      <NavBar />
      <main>
        <div class="header">
          <div class="left">
            <h1>Criação - Projeto Solar</h1>
          </div>
        </div>

        <div class="bottom-data">
          <div class="orders">
            <div class="header">
              <i class="bx bx-receipt"></i>
              <h3>Informações gerais</h3>
            </div>
            <div class="row">
              <div class="col-md-6 col-12">
                <div class="form-input mb-3">
                  <label for="formGroupExampleInput" class="form-label">
                    Nome do projeto
                  </label>
                  <input v-model="project_name" type="text" class="form-control" name="project_name"
                    placeholder="Digite o Nome do projeto" />
                </div>
              </div>
              <div class="col-md-3 col-12">
                <div class="form-input mb-3">
                  <label for="formGroupExampleInput" class="form-label">
                    Unidade Consumidora
                  </label>
                  <input v-model="consumer_unit" type="text" class="form-control" name="project_name"
                    placeholder="Informe a UC" />
                </div>
              </div>
              <div class="col-md-3 col-12">
                <div class="form-input mb-3">
                  <label for="formGroupExampleInput" class="form-label">
                    Será Empresa?
                  </label>
                  <div class="input-group mb-1">
                    <select class="form-control" v-model="is_legal_entity" @change="legalEntity">
                      <option value="0">Não</option>
                      <option value="1">Sim</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-12" :class="{ 'col-md-6': is_cpf, 'col-md-5': !is_cpf }">
                <div class="form-input mb-3">
                  <label for="formGroupExampleInput" class="form-label">
                    Nome do titular da UC
                  </label>
                  <input v-model="uc_holder_name" type="text" class="form-control" name="uc_holder_name"
                    placeholder="Digite o Nome do projeto" />
                </div>
              </div>
              <div class="col-md-3 col-6">
                <div class="form-input mb-3">
                  <label for="formGroupExampleInput" class="form-label">
                    RG
                  </label>
                  <input v-model="rg" type="text" class="form-control" name="rg" placeholder="0123456" />
                </div>
              </div>
              <div v-if="!is_cpf" class="col-md-4 col-6">
                <div class="form-input mb-3">
                  <label for="formGroupExampleInput" class="form-label">
                    Nome da Empresa
                  </label>
                  <input v-model="company_name" type="text" class="form-control" name="company_name"
                    placeholder="Razão Social" />
                </div>
              </div>
              <div class="col-md-3 col-6">
                <div class="form-input mb-3">
                  <label for="formGroupExampleInput" class="form-label">
                    {{ is_cpf ? 'CPF' : 'CNPJ' }}
                  </label>
                  <input v-if="is_cpf" v-model="cpf_cnpj" type="text" class="form-control" name="cpf_cnpj"
                    placeholder="000.000.000.-00" @change="autoUser" v-maska="'###.###.###-##'" />
                  <input v-if="!is_cpf" v-model="cpf_cnpj" type="text" class="form-control" name="cpf_cnpj"
                    placeholder="01.001.001/0001-01" @change="autoUser" v-maska="'##.###.###/####-##'" />
                </div>
              </div>
              <div class="col-md-4 col-6">
                <div class="form-input mb-3">
                  <label for="formGroupExampleInput" class="form-label" readonly>
                    E-mail
                  </label>
                  <input v-model="email" type="email" class="form-control" name="email"
                    placeholder="Digite um e-mail" />
                </div>
              </div>
              <div class="col-md-3 col-6">
                <div class="form-input mb-3">
                  <label for="formGroupExampleInput" class="form-label">
                    Telefone
                  </label>
                  <input v-maska="'(##) #####-####'" v-model="phone" class="form-label" />
                </div>
              </div>
              <div class="col-md-3 col-6">
                <div class="form-input mb-3">
                  <label for="formGroupExampleInput" class="form-label">
                    CEP
                  </label>
                  <input v-maska="'#####-###'" v-model="cep" class="form-label" @change="search" />
                </div>
              </div>
              <div class="col-md-3 col-6">
                <div class="form-input mb-3">
                  <label for="formGroupExampleInput" class="form-label" readonly>
                    Cidade
                  </label>
                  <input v-model="city" type="text" class="form-control" name="city" placeholder="Aguardando..."
                    readonly />
                </div>
              </div>
              <div class="col-md-3 col-6">
                <div class="form-input mb-3">
                  <label for="formGroupExampleInput" class="form-label" readonly>
                    Estado
                  </label>
                  <input v-model="state" type="text" class="form-control" name="state" placeholder="Aguardando..."
                    readonly />
                </div>
              </div>
              <div class="col-md-6 col-12">
                <div class="form-input mb-3">
                  <label for="formGroupExampleInput" class="form-label" readonly>
                    Logradouro
                  </label>
                  <input v-model="street" type="text" class="form-control" name="street" placeholder="Aguardando..."
                    readonly />
                </div>
              </div>
              <div class="col-md-3 col-6">
                <div class="form-input mb-3">
                  <label for="formGroupExampleInput" class="form-label" readonly>
                    Bairro
                  </label>
                  <input v-model="neighborhood" type="text" class="form-control" name="neighborhood"
                    placeholder="Aguardando..." readonly />
                </div>
              </div>
              <div class="col-md-2 col-6">
                <div class="form-input mb-3">
                  <label for="formGroupExampleInput" class="form-label" readonly>
                    Numero
                  </label>
                  <input v-model="address_number" type="text" class="form-control" name="address_number"
                    placeholder="Ex: 10" />
                </div>
              </div>
              <div class="col-md-6 col-12">
                <div class="form-input mb-3">
                  <label for="formGroupExampleInput" class="form-label" readonly>
                    Complemento
                  </label>
                  <input v-model="complement" type="text" class="form-control" name="complement"
                    placeholder="Ex: Casa, APT, Sítio, etc" />
                </div>

              </div>
            </div>

            <div class="row mt-5">
              <div class="col-12">
                <span class="form-label mb-3">
                  <h6 class="pl-10">Informação do Projeto</h6>
                </span>
              </div>
              <div class="col-md-3 col-12">
                <div class="form-input mb-3">
                  <label for="formGroupExampleInput" class="form-label">
                    Categoria do Cliente
                  </label>
                  <div class="input-group mb-1">
                    <select class="form-control" v-model="id_customer_category">
                      <option value="0">Escolher...</option>
                      <option value="1">Residencial</option>
                      <option value="2">Rural</option>
                      <option value="3">Comercial</option>
                      <option value="4">Industrial</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-md-3 col-12">
                <div class="form-input mb-3">
                  <label for="formGroupExampleInput" class="form-label">
                    Tipo de Ligação do Padrão
                  </label>
                  <div class="input-group mb-1">
                    <select class="form-control" v-model="id_connection_type">
                      <option value="0">Escolher...</option>
                      <option value="1">Monofasico</option>
                      <option value="2">Bifasico</option>
                      <option value="3">Trifasico</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-md-3 col-12">
                <div class="form-input mb-3">
                  <label for="formGroupExampleInput" class="form-label">
                    Disjuntor do Padrão
                  </label>
                  <div class="input-group mb-1">
                    <select class="form-control" v-model="id_circuit_breaker">
                      <option value="0">Escolher...</option>
                      <option value="1">30A</option>
                      <option value="2">40A</option>
                      <option value="3">50A</option>
                      <option value="4">60A</option>
                      <option value="5">63A</option>
                      <option value="6">70A</option>
                      <option value="7">80A</option>
                      <option value="8">100A</option>
                      <option value="9">150A</option>
                      <option value="10">200A</option>
                      <option value="11">250A</option>
                      <option value="12">300A</option>
                      <option value="13">350A</option>
                      <option value="14">400A</option>
                      <option value="15">450A</option>
                      <option value="16">500A</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-md-3 col-12">
                <div class="form-input mb-3">
                  <label for="formGroupExampleInput" class="form-label">
                    Bitola do Cabo do Padrão
                  </label>
                  <div class="input-group mb-1">
                    <select class="form-control" v-model="id_cable_size">
                      <option value="0">Escolher...</option>
                      <option value="1">6</option>
                      <option value="2">10</option>
                      <option value="3">16</option>
                      <option value="4">25</option>
                      <option value="5">35</option>
                      <option value="6">50</option>
                      <option value="7">70</option>
                      <option value="8">95</option>
                      <option value="9">120</option>
                      <option value="10">185</option>
                      <option value="11">220</option>
                      <option value="12">300</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-md-3 col-12">
                <div class="form-input mb-3">
                  <label for="formGroupExampleInput" class="form-label">
                    Marca do Modulo
                  </label>
                  <input type="text" class="form-control" name="module_mark" placeholder=""
                    v-model="module_mark" />
                </div>
              </div>
              <div class="col-md-3 col-12">
                <div class="form-input mb-3">
                  <label for="formGroupExampleInput" class="form-label">
                    Modelo do Modulo
                  </label>
                  <input type="text" class="form-control" name="module_model" placeholder="Modulo1; Modulo2; etc"
                    v-model="module_model" />
                </div>
              </div>
              <div class="col-md-3 col-12">
                <div class="form-input mb-3">
                  <label for="formGroupExampleInput" class="form-label">
                    Potência do Modulo (W)
                  </label>
                  <input type="number" class="form-control" name="module_power" placeholder="Ex: 10"
                    v-model="module_power" />
                </div>
              </div>
              <div class="col-md-3 col-12">
                <div class="form-input mb-3">
                  <label for="formGroupExampleInput" class="form-label">
                    Qtd. de Modulo
                  </label>
                  <input type="number" class="form-control" name="module_quantity" placeholder="Ex: 10"
                    v-model="module_quantity" />
                </div>
              </div>
              <div class="col-md-3 col-12">
                <div class="form-input mb-3">
                  <label for="formGroupExampleInput" class="form-label">
                    Marca do Inversor
                  </label>
                  <input type="text" class="form-control" name="inverter_mark" placeholder=""
                    v-model="inverter_mark" />
                </div>
              </div>
              <div class="col-md-3 col-12">
                <div class="form-input mb-3">
                  <label for="formGroupExampleInput" class="form-label">
                    Modelo do Inversor
                  </label>
                  <input type="text" class="form-control" name="inverter_model" placeholder="Modulo1; Modulo2; etc"
                    v-model="inverter_model" />
                </div>
              </div>
              <div class="col-md-3 col-12">
                <div class="form-input mb-3">
                  <label for="formGroupExampleInput" class="form-label">
                    Potência do Inversor (kW)
                  </label>
                  <input type="number" class="form-control" name="inverter_power" placeholder="Ex: 10"
                    v-model="inverter_power" />
                </div>
              </div>
              <div class="col-md-3 col-12">
                <div class="form-input mb-3">
                  <label for="formGroupExampleInput" class="form-label">
                    Qtd. de Inversor
                  </label>
                  <input type="number" class="form-control" name="inverter_quantity" placeholder="Ex: 10"
                    v-model="inverter_quantity" />
                </div>
              </div>
              <div class="col-md-3 col-12">
                <div class="form-input mb-3">
                  <label for="formGroupExampleInput" class="form-label">
                    Potência do Transformador (Se ouver)
                  </label>
                  <input type="number" class="form-control" name="inverter_quantity" placeholder="Ex: 10KVA"
                    v-model="transformer_power" />
                </div>
              </div>

            </div>
            <div class="row mt-5">
              <div v-if="role == 2" class="col-12">
                <span class="form-label mb-3">
                  <h6 class="pl-10">Informações Extras</h6>
                </span>
              </div>
              <div v-if="role == 2" class="col-md-4 col-12">
                <div class="form-input mb-3">
                  <label for="formGroupExampleInput" class="form-label">
                    Modalidade
                  </label>
                  <div class="input-group mb-1">
                    <select class="form-control" v-model="modality">
                      <option value="0">Escolher...</option>
                      <option value="Geração na própria UC">Geração na própria UC</option>
                      <option value="Auto consumo remoto">Auto consumo remoto</option>
                      <option value="Compartilhada">Compartilhada</option>
                      <option value="Condomínio">Condomínio</option>
                    </select>
                  </div>
                </div>
              </div>
              <div v-if="role == 2" class="col-md-4 col-12">
                <div class="form-input mb-3">
                  <label for="formGroupExampleInput" class="form-label">
                    Classes
                  </label>
                  <div class="input-group mb-1">
                    <select class="form-control" v-model="class_group">
                      <option value="0">Escolher...</option>
                      <option value="Comercial">Comercial</option>
                      <option value="Iluminação pública">Iluminação pública</option>
                      <option value="Industrial">Industrial</option>
                      <option value="Poder Público">Poder Público</option>
                      <option value="Residencial">Residencial</option>
                      <option value="Rural">Rural</option>
                      <option value="Serviço Público">Serviço Público</option>
                    </select>
                  </div>
                </div>
              </div>
              <div v-if="role == 2" class="col-md-4 col-12">
                <div class="form-input mb-3">
                  <label for="formGroupExampleInput" class="form-label">
                    Subgrupo
                  </label>
                  <div class="input-group mb-1">
                    <select class="form-control" v-model="subgroup">
                      <option value="0">Escolher...</option>
                      <option value="A1">A1</option>
                      <option value="A2">A2</option>
                      <option value="A3">A3</option>
                      <option value="A3a">A3a</option>
                      <option value="A4">A4</option>
                      <option value="AS">AS</option>
                      <option value="B1">B1</option>
                      <option value="B2">B2</option>
                      <option value="B3">B3</option>
                      <option value="B4">B4</option>
                    </select>
                  </div>
                </div>
              </div>
              <div v-if="role == 2" class="col-md-4 col-12">
                <div class="form-input mb-3">
                  <label for="formGroupExampleInput" class="form-label">
                    Data da implantação da unidade geradora
                  </label>
                  <input type="datetime-local" class="form-control" name="transformer_power"
                    v-model="installation_date" />
                </div>
              </div>
              <div v-if="role == 2" class="col-md-4 col-12">
                <div class="form-input mb-3">
                  <label for="formGroupExampleInput" class="form-label">
                    Data da conexão da unidade Geradora na Distribuidora:
                  </label>
                  <input type="datetime-local" class="form-control" name="transformer_power"
                    v-model="connection_date" />
                </div>
              </div>
              <div class="col-md-3 col-12">
                <div class="form-input mb-3">
                  <label for="formGroupExampleInput" class="form-label">
                    Qtd. de UCs que recebem os créditos:
                  </label>
                  <input type="number" class="form-control" name="transformer_power" v-model="credited_ucs_quantity" />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6 col-12">
                <div class="row">
                  <div class="col-md-6 col-12">
                    <div class="form-input mb-3">
                      <label for="formGroupExampleInput" class="form-label">
                        Latitude (Graus Decimais)
                      </label>
                      <input type="text" class="form-control" name="transformer_power" v-model="latitude"
                        @input="updateMarker()" />
                    </div>
                  </div>
                  <div class="col-md-6 col-12">
                    <div class="form-input mb-3">
                      <label for="formGroupExampleInput" class="form-label">
                        Longitude (Graus Decimais)
                      </label>
                      <input type="text" class="form-control" name="transformer_power" v-model="longitude"
                        @input="updateMarker()" />
                    </div>
                  </div>
                  <div class="col-12">
                    <p>
                      <strong>Graus, Minutos e Segundos (DMS):</strong> <br>
                      Latitude: {{ convertToDMS(latitude) }} | Longitude: {{ convertToDMS(longitude) }}
                    </p>
                  </div>
                  <div class="col-12">
                    <p><strong>UTM:</strong> <br> Zone: {{ utm.zone }} <br> Longitude UTM: {{ utm.easting }} <br>
                      Latitude UTM: {{ utm.northing }}</p>
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-12">
                <div id="map" style="height: 500px; width: 100%; margin-top: 20px;"></div>
              </div>
            </div>
            <div v-if="role == 2" class="row mt-5">
              <div class="col-12">
                <span class="form-label mb-3">
                  <h6 class="pl-10">Informação do Integrador</h6>
                </span>
              </div>

              <div class="col-md-6 col-12">
                <div class="form-input mb-3">
                  <label for="formGroupExampleInput" class="form-label">
                    Qual será o Integrador?
                  </label>
                  <div class="input-group mb-1">
                    <select class="form-control" v-model="integrator">
                      <option value="0">Escolher...</option>
                      <option v-for="intergrator in intergrators" :key="intergrator.id" :value="intergrator.id">
                        {{ (intergrator.company_name) ? intergrator.company_name : intergrator.full_name }}</option>
                    </select>
                  </div>
                </div>
              </div>

            </div>
            <div v-if="role == 2" class="row mt-5">
              <div class="col-12">
                <span class="form-label mb-3">
                  <h6 class="pl-10">Financeiro</h6>
                </span>
              </div>

              <div class="col-md-4 col-12">
                <div class="form-input mb-3">
                  <label for="formGroupExampleInput" class="form-label">
                    Qual será o valor do projeto?
                  </label>
                  <div class="input-group mb-1">
                    <money3 v-model="amount_project" v-bind="config"></money3>
                  </div>
                </div>
              </div>
              <div class="col-md-4 col-12">
                <div class="form-input mb-3">
                  <label for="formGroupExampleInput" class="form-label">
                    Qual será o valor do ATR/TRT?
                  </label>
                  <div class="input-group mb-1">
                    <money3 v-model="amount_art_trt" v-bind="config"></money3>
                  </div>
                </div>
              </div>
              <div class="col-md-4 col-12">
                <div class="form-input mb-3">
                  <label for="formGroupExampleInput" class="form-label">
                    Qual o valor pago?
                  </label>
                  <div class="input-group mb-1">
                    <money3 v-model="amount_paid" v-bind="config"></money3>
                  </div>
                </div>
              </div>

            </div>
            <div class="row">
              <div class="col-12">
                <div class="form-input mt-3">
                  <label for="formGroupExampleInput" class="form-label">
                    Observação
                  </label>
                  <div class="areatext">
                    <textarea v-model="observation" placeholder="Descrição do Projeto (Opcional)"></textarea>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-5">
              <div class="col-12">
                <span class="form-label ">
                  <h6 class="pl-10 mb-3">Anexos</h6>
                </span>
              </div>
              <!-- Select para adicionar anexos -->
              <div class="col-md-5 col-12 mb-3">
                <label for="anexoTipo" class="form-label">Tipos de anexos</label>
                <select v-model="selectedAnexo" @change="handleAnexoSelection" class="form-control">
                  <option value="0" disabled>Escolha o tipo de anexo</option>
                  <option v-for="option in availableAnexoOptions" :key="option.id" :value="option">
                    {{ option.name }}
                  </option>
                </select>
              </div>
              <div class="col-12">
                <div class="row">

                  <!-- Exibe o campo de nome e arquivo diretamente para "Outros" -->
                  <div v-if="isOtherSelected" class="col-md-4 mb-3">
                    <label for="otherAnexoLabel" class="form-label">Nome do Anexo</label>
                    <div class="form-input">
                      <input v-model="customAnexoName" type="text" class="form-control"
                        placeholder="Digite o nome do anexo" />
                      <button @click="addCustomAnexo" class="btn btn-sm btn-success mt-2">Adicionar campo</button>
                    </div>

                  </div>
                </div>
              </div>

              <div class="col-12">
                <div class="row">
                  <!-- Loop para renderizar os campos de anexo (gerados após o nome) -->
                  <div v-for="(anexo, index) in anexos" :key="anexo.name" class="col-md-4 col-12 mb-3">
                    <div class="form-input">
                      <label :for="anexo.name" class="form-label">{{ anexo.label }}</label>

                    </div>
                    <input :id="anexo.name" ref="anexo.name" type="file"
                      @change="handleFileChange(anexo.name, $event)" />
                    <button @click="removeAnexo(index)" class="btn btn-sm btn-danger mt-2">Remover</button>
                  </div>
                </div>
              </div>


              <div v-if="!is_cpf" class="col-md-6 col-12 mb-3">
                <div class="form-input">
                  <label for="formGroupExampleInput" class="form-label">
                    Cartão CNPJ
                  </label>
                </div>
                <input id="anexo_7" ref="anexo_7" type="file" class="form-control" name="anexo_7" />
              </div>
              <div v-if="!is_cpf" class="col-md-6 col-12 mb-3">
                <div class="form-input">
                  <label for="formGroupExampleInput" class="form-label">
                    Contrato Social
                  </label>
                </div>
                <input id="anexo_8" ref="anexo_8" type="file" class="form-control" name="anexo_8" />
              </div>
            </div>
            <div class="w-100 d-flex align-items-center justify-content-end mt-5">
              <button class="btn btn-primary btn-all" @click="create">
                <span>Gerar Projeto</span>
              </button>
            </div>
          </div>
        </div>

      </main>
    </div>
  </div>
</template>

<script>
import Cookie from 'js-cookie'
import NavBar from "@/components/NavBar.vue";
import Sidebar from "@/components/SideBar.vue";

import L from "leaflet";
import "leaflet/dist/leaflet.css";

import proj4 from "proj4";


import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";

// Configura os ícones
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
});

export default {
  components: {
    NavBar,
    Sidebar
  },
  data() {
    return {
      isSubmit: false,
      intergrators: [],
      project_name: '',
      consumer_unit: '',
      uc_holder_name: '',
      email: '',
      cpf_cnpj: '',
      rg: '',
      phone: '',
      street: '',
      address_number: '',
      neighborhood: '',
      city: '',
      state: '',
      cep: '',
      company_name: '',
      observation: '',
      has_attachment: '',
      complement: '',
      type: 1,
      is_legal_entity: 0,
      integrator: 0,
      is_cpf: true,
      role: this.$store.state.role,
      token: Cookie.get('_token'),
      editorOptions: {
        theme: 'snow',
        boundary: document.body,
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            ['blockquote'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            ['clean'],
          ]
        },
        placeholder: '',
        readOnly: false
      },


      //Tipo Solar
      id_customer_category: 0,
      id_connection_type: 0,
      id_circuit_breaker: 0,
      id_cable_size: 0,
      module_mark: '',
      module_model: '',
      module_power: '',
      module_quantity: '',
      inverter_mark: '',
      inverter_model: '',
      inverter_power: '',
      inverter_quantity: '',
      transformer_power: '',

      credited_ucs_quantity: '',
      latitude: '',
      longitude: '',
      installation_date: '',
      connection_date: '',
      modality: 0,
      class_group: 0,
      subgroup: 0,

      //Financeiro
      amount_project: 0,
      amount_art_trt: 0,
      amount_paid: 0,
      config: {
        masked: false,
        prefix: 'R$ ',
        suffix: '',
        thousands: '.',
        decimal: ',',
        precision: 2,
        disableNegative: false,
        disabled: false,
        min: null,
        max: null,
        allowBlank: false,
        minimumNumberOfCharacters: 0,
        shouldRound: true,
        focusOnRight: false,
      },

      selectedAnexo: 0, // Armazena o anexo selecionado do select
      customAnexoName: '', // Nome personalizado para "Outros"
      isOtherSelected: false, // Controla quando o campo de nome personalizado é mostrado
      anexos: [], // Lista de anexos dinâmicos
      anexosFiles: {}, // Armazena os arquivos selecionados
      nextAnexoId: 100, // Para criar nomes dinâmicos para anexos "Outros"
      anexoOptions: [
        { id: 1, name: 'Procuração' },
        { id: 2, name: 'Documento Pessoa Física' },
        { id: 3, name: 'Conta de Energia' },
        { id: 4, name: 'Foto do local' },
        { id: 5, name: 'Imagem com localização' },
        { id: 6, name: 'Relação de cargas' },
        { id: 7, name: 'Cartão CNPJ' },
        { id: 8, name: 'Contrato Social' },
        { id: 9, name: 'Projeto Arquitetônico' },
        { id: 10, name: 'Foto do padrão' },
        { id: 11, name: 'Foto do disjuntor do padrão' },
        { id: 12, name: 'Outros' }
      ],
      usedAnexos: [], // Lista para armazenar os anexos já usados (exceto "Outros")

      map: null,
      marker: null,
      defaultLatitude: -10.9472,
      defaultLongitude: -62.8272,
      utm: { zone: "", easting: "", northing: "" }, // Dados UTM
      lastCpfCnpj: ''
    };
  },
  methods: {
    handleAnexoSelection() {
      if (this.selectedAnexo.name === 'Outros') {
        this.isOtherSelected = true; // Exibe o campo de nome para "Outros"
      } else {
        this.addAnexo(); // Adiciona diretamente os anexos que não são "Outros"
      }
    },
    addCustomAnexo() {
      // Adiciona o bloco para o anexo do tipo "Outros" com o nome e gera o campo de arquivo
      if (this.customAnexoName) {
        const newAnexoName = `anexo_${this.nextAnexoId++}`;

        // Adiciona o bloco de anexo com o nome
        this.anexos.push({
          id: this.nextAnexoId,
          name: newAnexoName,
          label: this.customAnexoName
        });

        // Limpa o campo de nome e oculta o campo "Outros"
        this.customAnexoName = '';
        this.isOtherSelected = false; // Reseta a seleção para permitir adicionar outro "Outros"
        this.selectedAnexo = 0; // Reseta o select para permitir novas seleções
      }
    },
    handleFileChange(anexoName, event) {
      this.anexosFiles[anexoName] = event.target.files[0]; // Armazena o arquivo no estado
    },
    addAnexo() {
      const anexoLabel = this.selectedAnexo.name;
      const anexoId = this.selectedAnexo.id;

      if (anexoLabel) {
        const newAnexoName = `anexo_${anexoId}`;

        this.anexos.push({
          id: anexoId,
          name: newAnexoName,
          label: anexoLabel
        });

        this.usedAnexos.push(this.selectedAnexo.id); // Marca como usado
        this.selectedAnexo = 0; // Reseta o select após adicionar o anexo
      }
    },
    removeAnexo(index) {
      const anexo = this.anexos[index];
      if (anexo.id !== this.nextAnexoId - 1) { // Se não for um anexo do tipo "Outros"
        this.usedAnexos = this.usedAnexos.filter(id => id !== anexo.id); // Remove dos usados
      }
      this.anexos.splice(index, 1); // Remove o anexo da lista
      delete this.anexosFiles[anexo.name]; // Remove o arquivo associado
    },
    clear() {
      this.project_name = '';
      this.consumer_unit = '';
      this.uc_holder_name = '';
      this.cpf_cnpj = '';
      this.rg = '';
      this.phone = '';
      this.street = '';
      this.address_number = '';
      this.neighborhood = '';
      this.city = '';
      this.state = '';
      this.cep = '';
      this.company_name = '';
      this.observation = '';
      this.has_attachment = '';
      this.complement = '';
      this.type = 1;
      this.is_legal_entity = 0;
      this.integrator = 0;
      this.is_cpf = true;

      //Info Solar
      this.id_customer_category = 0;
      this.id_connection_type = 0;
      this.id_circuit_breaker = 0;
      this.id_cable_size = 0;
      this.module_model = 0;
      this.module_power = 0;
      this.module_quantity = 0;
      this.inverter_model = 0;
      this.inverter_power = 0;
      this.inverter_quantity = 0;

      this.anexo_1 = '';
      this.anexo_2 = '';
      this.anexo_3 = '';
      this.anexo_5 = '';

      this.anexo_7 = '';
      this.anexo_8 = '';
      this.anexo_10 = '';
      this.anexo_11 = '';

    },
    showAlert(type, msg) {
      var textMsg = "";

      if (msg.message) {


        if (typeof msg.errors === 'object' && msg.errors) {
          for (const key in msg.errors) {
            if (Object.prototype.hasOwnProperty.call(msg.errors, key)) {
              const errorMessages = msg.errors[key];
              textMsg += `${errorMessages.join(', ')}<br>`;
            }
          }
        } else {
          textMsg = `${msg.message}`;
        }
      } else {
        textMsg = `${msg}`;
      }

      this.$swal({
        icon: type,
        confirmButtonText: 'Confirmar',
        html: textMsg
      });
    },
    amountConvert(value) {
      return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    },
    legalEntity() {
      this.is_cpf = !this.is_cpf;
      this.cpf_cnpj = '';
    },
    create() {

      if (this.isSubmit) return;

      if (this.role == 2 && this.integrator == 0) {
        return this.showAlert('error', 'Escolha um integrador para o projeto.');
      }

      let isValidCoordinate = this.isValidCoordinate(this.latitude, this.longitude);
      if (!isValidCoordinate) {
        this.showAlert('warning', 'As coordenadas informadas não são válidas.');
        return;
      }

      const formData = new FormData();

      // Cria o objeto JSON com os dados
      const json = {
        project_name: this.project_name,
        consumer_unit: this.consumer_unit,
        uc_holder_name: this.uc_holder_name,
        cpf_cnpj: this.cpf_cnpj,
        email: this.email,
        rg: this.rg,
        phone: this.phone,
        street: this.street,
        address_number: this.address_number,
        neighborhood: this.neighborhood,
        city: this.city,
        state: this.state,
        zip_code: this.cep,
        company_name: this.company_name,
        observation: this.observation,
        has_attachment: this.has_attachment,
        complement: this.complement,
        project_type: this.type,
        is_legal_entity: this.is_legal_entity,
        integrator: (this.role == 2) ? this.integrator : 0,

        amount_project: this.amount_project,
        amount_art_trt: this.amount_art_trt,
        amount_paid: this.amount_paid,

        id_customer_category: this.id_customer_category,
        id_connection_type: this.id_connection_type,
        id_circuit_breaker: this.id_circuit_breaker,
        id_cable_size: this.id_cable_size,
        module_mark: this.module_mark,
        module_model: this.module_model,
        module_power: this.module_power,
        module_quantity: this.module_quantity,
        inverter_mark: this.inverter_mark,
        inverter_model: this.inverter_model,
        inverter_power: this.inverter_power,
        inverter_quantity: this.inverter_quantity,
        transformer_power: this.transformer_power,

        credited_ucs_quantity: this.credited_ucs_quantity,
        latitude: this.latitude,
        longitude: this.longitude,
        installation_date: this.installation_date,
        connection_date: this.connection_date,
        modality: this.modality,
        class_group: this.class_group,
        subgroup: this.subgroup,

        anexos: {},
      };

      let loader = this.$loading.show({
        container: this.fullPage,
        canCancel: false,
      });

      this.anexos.forEach(anexo => {
        if (this.anexosFiles[anexo.name]) {

          formData.append(anexo.name, this.anexosFiles[anexo.name]);
          formData.append(`${anexo.name}_name`, anexo.label);
        }
      });

      Object.keys(json).forEach(key => {
        formData.append(key, json[key]);
      });

      this.isSubmit = true;

      this.$http
        .post("user/projects", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            "Authorization": "Bearer " + this.token
          },
        })
        .then((response) => {
          //this.clear();
          loader.hide();
          this.showAlert('success', response.data.message);
          this.$router.push('/projetos/solar');
          this.isSubmit = false;
          
        })
        .catch((error) => {
          loader.hide()
          if (error.response && error.response.data) {
            this.showAlert('error', error.response.data);
          } else {
            this.showAlert('error', 'Ocorreu um erro desconhecido. Entre em contato com a equipe de desenvolvimento. 1');
          }

          this.isSubmit = false;

        });
    },
    loadIntergrator() {
      this.$http.get("user/integrators", {
        headers: {
          "Authorization": "Bearer " + this.token
        },
      })
        .then((response) => {
          this.intergrators = response.data.items;
        })
        .catch((error) => {
          if (error.response && error.response.data) {
            this.showAlert('error', error.response.data);
          } else {
            this.showAlert('error', 'Ocorreu um erro desconhecido. Entre em contato com a equipe de desenvolvimento. 2');
          }

        });
    },
    search() {
      if (!this.cep || this.cep.length < 9) {

        return;
      }

      this.$http.get('/cep/' + this.cep)
        .then((response) => {
          this.street = response.data.logradouro;
          this.neighborhood = response.data.bairro;
          this.city = response.data.localidade;
          this.state = response.data.uf;

          const inputs = this.$el.querySelectorAll('input[readonly]');

          inputs.forEach(input => {
            input.removeAttribute('readonly');
          });

        }).catch((error) => {
          if (error.response && error.response.data) {
            this.showAlert('error', error.response.data);
          } else {
            this.showAlert('error', 'Ocorreu um erro desconhecido. Entre em contato com a equipe de desenvolvimento. 3');
          }
        })
    },
    autoUser() {
      console.log("ok")
      //if (!this.isSearch) return;

      const rawCpfCnpj = this.cpf_cnpj.replace(/\D/g, '');

      const isCpf = this.is_legal_entity == 0;
      const isCnpj = this.is_legal_entity == 1;

      // Limita execução apenas se o valor for exatamente o necessário
      if ((isCpf && rawCpfCnpj.length !== 11) || (isCnpj && rawCpfCnpj.length !== 14)) {
        return;
      }

      if (rawCpfCnpj === this.lastCpfCnpj) return;

      this.lastCpfCnpj = rawCpfCnpj;

      const json = {
        number: this.cpf_cnpj,
        type: this.is_legal_entity,
      };

      this.$http.post('/user/search', json, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Authorization": "Bearer " + this.token,
        },
      })
        .then((response) => {
          if (!response.data.status) return;

          const items = response.data.items;
          this.uc_holder_name = items.full_name;
          this.rg = items.rg;
          this.phone = items.phone;
          this.state = items.state;
          this.integrator = items.integrators;
          this.is_legal_entity = items.is_legal_entity;

          if (this.is_legal_entity && response.data.extra) {
            this.company_name = response.data.extra.company_name;
          }

          this.address_number = items.address_number;
          this.street = items.street;
          this.neighborhood = items.neighborhood;
          this.city = items.city;
          this.state = items.state;
          this.cep = items.zip_code;
          this.complement = items.complement;

          const inputs = this.$el.querySelectorAll('input[readonly]');
          inputs.forEach(input => input.removeAttribute('readonly'));
        })
        .catch((error) => {
          const msg = error.response?.data || '[09] Ocorreu um erro desconhecido.';
          this.showAlert('error', msg);
        });
    },
    convertToDMS(decimal) {
      const degrees = Math.floor(Math.abs(decimal));
      const minutes = Math.floor((Math.abs(decimal) - degrees) * 60);
      const seconds = ((Math.abs(decimal) - degrees - minutes / 60) * 3600).toFixed(2);
      const direction = decimal >= 0 ? (this.latitude === decimal ? "N" : "O") : (this.latitude === decimal ? "S" : "L");

      return `${degrees}° ${minutes}' ${seconds}" ${direction}`;
    },
    initializeMap() {
      // Inicializa o mapa
      let isValidCoordinate = this.isValidCoordinate(this.latitude, this.longitude);
      if (!isValidCoordinate) {
        this.showAlert('warning', 'As coordenadas informadas não são válidas. O mapa não será exibido.');
        return;
      }
      this.map = L.map("map").setView([this.latitude, this.longitude], 13);

      // Adiciona o tile do mapa
      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution: '',
      }).addTo(this.map);


      const latitude = this.latitude ?? this.defaultLatitude;
      const longitude = this.longitude ?? this.defaultLongitude;

      // Adiciona um marcador inicial
      this.marker = L.marker([latitude,longitude], {
        draggable: true,
      }).addTo(this.map);

      // Atualiza os inputs quando o marcador for movido
      this.marker.on("dragend", (event) => {
        const { lat, lng } = event.target.getLatLng();
        this.latitude = lat.toFixed(6);
        this.longitude = lng.toFixed(6);

        this.updateUTM();

      });
    },
    updateMarker() {
      // Atualiza a posição do marcador no mapa
      if (this.marker) {
        this.marker.setLatLng([this.latitude, this.longitude]);
        this.map.setView([this.latitude, this.longitude], this.map.getZoom());
      }
    },
    getUTMLetter(latitude) {
      let isValidCoordinate = this.isValidCoordinate(this.latitude, this.longitude);
      if (!isValidCoordinate) {
        this.showAlert('warning', 'As coordenadas informadas não são válidas. O mapa não será exibido.');
        return;
      }

      if(!this.latitude || this.longitude) return;
      latitude = parseFloat(latitude); // Garante que é um número

      if (latitude >= 84) return "X"; // Latitude máxima do sistema UTM
      if (latitude < -80) return "C"; // Latitude mínima do sistema UTM

      const letters = "CDEFGHJKLMNPQRSTUVWX"; // Letras válidas no sistema UTM
      const index = Math.floor((latitude + 80) / 8); // Divide a latitude em faixas de 8 graus

      if (index < 0 || index >= letters.length) {
        console.error(`Latitude fora do intervalo permitido (-80 a 84): ${latitude}`);
        return "Invalid"; // Valor inválido para zonas fora do alcance
      }

      console.log(`Latitude: ${latitude}, Index: ${index}, Letter: ${letters[index]}`);
      return letters[index];
    },

    updateUTM() {

      let isValidCoordinate = this.isValidCoordinate(this.latitude, this.longitude);
      if (!isValidCoordinate) {
        this.showAlert('warning', 'As coordenadas informadas não são válidas. O mapa não será exibido.');
        return;
      }

      if(!this.latitude || this.longitude) return;

      const zoneNumber = Math.floor((parseFloat(this.longitude) + 180) / 6) + 1; // Calcula o número da zona
      const zoneLetter = this.getUTMLetter(parseFloat(this.latitude)); // Garante que a latitude é um número

      if (zoneLetter === "Invalid") {
        console.error("Letra da zona não foi calculada corretamente.");
        return; // Interrompe a execução em caso de erro
      }

      const [easting, northingRaw] = proj4("EPSG:4326", `+proj=utm +zone=${zoneNumber} +datum=WGS84 +units=m +no_defs`, [
        parseFloat(this.longitude),
        parseFloat(this.latitude),
      ]);

      // Ajusta o Northing para o hemisfério sul
      const northing = this.latitude >= 0 ? northingRaw : northingRaw + 10000000;

      // Atualiza os valores UTM
      this.utm = {
        zone: `${zoneNumber} ${zoneLetter}`, // Ex.: "20 L"
        easting: `${easting.toFixed(2)} m E`,
        northing: `${northing.toFixed(2)} m ${this.latitude >= 0 ? "N" : "S"}`,
      };
    },
    isValidCoordinate(latitude, longitude) {
      const lat = parseFloat(latitude);
      const lon = parseFloat(longitude);

      if (isNaN(lat) || isNaN(lon)) {
        return false;
      }

      const isLatitudeValid = lat >= -90 && lat <= 90;
      const isLongitudeValid = lon >= -180 && lon <= 180;

      return isLatitudeValid && isLongitudeValid;
    }
  },
  created() {
    this.loadIntergrator();
  },
  mounted() {
    this.initializeMap();
    this.updateUTM();
  },
  computed: {
    // Filtra as opções disponíveis, removendo as que já foram adicionadas
    availableAnexoOptions() {
      return this.anexoOptions.filter(option => {
        return option.name === 'Outros' || !this.usedAnexos.includes(option.id);
      });
    }
  },
};
</script>
